import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'nuso-confirm-dialog2',
    template: `
    <h2 mat-dialog-title>{{ data.title || 'Confirm' }}
      @if (data.icon && data.iconColor) {
        <mat-icon style="margin-left:5px; color:{{data.iconColor}}">{{data.icon}}</mat-icon>
      }
      @if (data.icon && !data.iconColor) {
        <mat-icon style="margin-left:5px">{{data.icon}}</mat-icon>
      }
    </h2>
    <mat-dialog-content>
      <div [innerHTML]="data.message"></div>
    </mat-dialog-content>
    <mat-dialog-actions [align]="data.align || 'start'">
      <button mat-raised-button (click)="onConfirm()">{{ data.confirmText || 'OK' }}</button>
      @if (!data.noCancel) {
        <button mat-button (click)="onCancel()">{{data.cancelText || 'Cancel'}}</button>
      }
    </mat-dialog-actions>
    `,
    standalone: false
})
export class ConfirmDialog2Component {
  dialogRef = inject<MatDialogRef<ConfirmDialog2Component>>(MatDialogRef);
  data = inject<{
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    noCancel?: boolean;
    icon?: string;
    iconColor?: string;
    align?: 'start' | 'end' | 'center';
}>(MAT_DIALOG_DATA);


  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}